import { Product } from "shared/api/middleware-api-client";
import Heading from "shared/ui/typography/Heading";
import { getProductExtraOptionNames } from "entities/configurator/model/extraOptionDisplay";

export const DoorModal = (props: {
  product: Product;
  isSelfAssembly: boolean;
}) => {
  const headClass = "gg-px-5 gg-pt-3 gg-text-start";
  const cellClass = "gg-px-5 gg-pb-4 gg-pt-0";
  const montageText = props.isSelfAssembly
    ? "Zelf monteren"
    : "Montage door GewoonGers";
  const extraOptionsNames = getProductExtraOptionNames(props.product);

  return (
    <>
      <table className="gg-w-full gg-bg-gray-100">
        <thead>
          <tr>
            <th className={headClass}>
              <Heading headingLevel="h5">Ontwerp</Heading>
            </th>
            <th className={headClass}>
              <Heading headingLevel="h5">Kleur</Heading>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={cellClass}>
              <p>{props.product.doorLayout.name}</p>
            </td>
            <td className={cellClass}>
              <p>{props.product.doorColor.name}</p>
            </td>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th className={headClass}>
              <Heading headingLevel="h5">Deurbeslag</Heading>
            </th>
            <th className={headClass}>
              <Heading headingLevel="h5">Glas</Heading>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={cellClass}>
              <p>{props.product.doorHandle.name}</p>
            </td>
            <td className={cellClass}>
              <p>{props.product.glassType.name}</p>
            </td>
          </tr>
        </tbody>

        <thead>
          <tr>
            <th className={headClass}>
              <Heading headingLevel="h5">Extra opties</Heading>
            </th>

            <th className={headClass}>
              <Heading headingLevel="h5">Montagewijze</Heading>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="">
            <td className={cellClass}>
              <ul className="">
                {extraOptionsNames.length ? (
                  extraOptionsNames.map((name, index) => (
                    <li
                      className={index === 0 ? "gg-pt-1" : ""}
                      key={props.product.extraOptions[index].id}
                    >
                      - {name}
                    </li>
                  ))
                ) : (
                  <>-</>
                )}
              </ul>
            </td>

            <td
              data-testid="modal-montage-choice"
              className="gg-px-5 gg-pb-4 gg-pt-1 gg-align-top"
            >
              {montageText}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};
